export const RouteConstants = {
  root: '/',
  defaultRoute: '/data-sources',
  home: '/home',
  callbackLanding: '/cb',
  logout: '/logout',
  createWorkspace: '/create-workspace',
  createCompany: '/create-company',
  dataSources: '/data-sources',
  dataSourcesCatalog: '/data-sources?catalog',
  dataSourcesCreate: '/data-sources/create/:id',
  audiences: '/audiences',
  audiencesCreate: '/audiences/create',
  destinations: '/destinations',
  createDestination: '/destinations/create',
  createCustomDestination: '/destinations/create-custom',
  reports: '/reports',
  componentShowcase: '/components-list',
  settings: '/settings',
  company: '/settings/company',
  cyclrAuthRedirect: '/cyclr/auth/redirect',
  campaigns: '/campaigns',
  createCampaign: '/campaigns/create',
  whatsappCampaigns: '/campaigns/whatsapp/campaigns',
  createCampaignWhatsapp: '/campaigns/whatsapp/campaigns/create',
  whatsappCampaignDetails: '/campaigns/whatsapp/campaigns/:campaignId',
  editCampaignWhatsapp: '/campaigns/whatsapp/campaigns/:campaignId/edit',
  createCampaignWhatsappLegacy: '/campaigns/create/whatsapp',
  whatsappTemplates: '/campaigns/whatsapp/templates',
  createWhatsappTemplate: '/campaigns/whatsapp/templates/create',
  whatsappTemplateDetails: '/campaigns/whatsapp/templates/:templateId',
  editWhatsappTemplate: '/campaigns/whatsapp/templates/:templateId/edit',
  /** TODO: map to final route when workspace templates hub / settings screen exists */
  whatsappTemplatesEditHub: '/campaigns/whatsapp/templates/hub/edit',
  whatsappTemplatesDeleteHub: '/campaigns/whatsapp/templates/hub/delete',
  whatsappPackages: '/campaigns/whatsapp/packages',
  smsCampaigns: '/campaigns/sms/campaigns',
  createCampaignSms: '/campaigns/sms/campaigns/create',
  smsCampaignDetails: '/campaigns/sms/campaigns/:campaignId',
  editCampaignSms: '/campaigns/sms/campaigns/:campaignId/edit',
  smsTemplates: '/campaigns/sms/templates',
  createSmsTemplate: '/campaigns/sms/templates/create',
  smsTemplateDetails: '/campaigns/sms/templates/:templateId',
  editSmsTemplate: '/campaigns/sms/templates/:templateId/edit',
  emailCampaigns: '/campaigns/email/campaigns',
  createCampaignEmail: '/campaigns/email/campaigns/create',
  emailCampaignDetails: '/campaigns/email/campaigns/:campaignId',
  editCampaignEmail: '/campaigns/email/campaigns/:campaignId/edit',
  emailTemplates: '/campaigns/email/templates',
  createEmailTemplate: '/campaigns/email/templates/create',
  emailTemplateDetails: '/campaigns/email/templates/:templateId',
  editEmailTemplate: '/campaigns/email/templates/:templateId/edit',
  /** Connector-flow hubs for email templates (mirrors WhatsApp hub routes) */
  emailTemplatesEditHub: '/campaigns/email/templates/hub/edit',
  emailTemplatesDeleteHub: '/campaigns/email/templates/hub/delete',
  emailPackages: '/campaigns/email/packages',
  support: '/support',
  unifiedProfiles: '/unified-profiles',
  resetPassword: '/reset-password',
  marketIntellingence: '/market-intelligence',
  campaignsV2: {
    sms: {
      index: '/',
    },
    whatsapp: {
      index: '/',
    },
    email: {
      index: '/',
    },
  },
} as const;

export const SidebarRoutes = [
  RouteConstants.home,
  RouteConstants.campaigns,
  RouteConstants.dataSources,
  RouteConstants.audiences,
  RouteConstants.destinations,
  RouteConstants.unifiedProfiles,
  RouteConstants.reports,
  RouteConstants.componentShowcase,
  RouteConstants.settings,
  RouteConstants.cyclrAuthRedirect,
  RouteConstants.marketIntellingence,
];

export default RouteConstants;
